export default "__VITE_ASSET__a26f5cb6__"